import { render, staticRenderFns } from "./ViewCertification.vue?vue&type=template&id=22dd14fe&"
import script from "./ViewCertification.vue?vue&type=script&lang=js&"
export * from "./ViewCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports